import React from "react";
import { useEffect } from "react";

export default function Index() {
  useEffect(() => {
    localStorage.clear();
    window.location.href = "/";
  }, []);
  return <div></div>;
}
